import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function Terminals() {
  const terminals = [
    {
      name: 'Jurong Port',
      location: 'Singapore',
      description: 'Strategic petroleum terminal in Singapore\'s premier industrial port, serving as a key hub for Southeast Asian petroleum distribution. Our facility at Jurong Port provides comprehensive storage and transshipment services with state-of-the-art tank farm infrastructure.',
      facilities: 'Tank farm capacity: 25,000 m³, Deep-water berths, Advanced loading systems, 24/7 operations',
      image: 'https://public.readdy.ai/ai/img_res/92723a656ccd40a0c28c667723a45b9f.jpg',
      showLogo: true
    },
    {
      name: 'Rotterdam Port',
      location: 'Netherlands',
      description: 'Europe\'s largest port and a critical gateway for petroleum products entering the European market. Our Rotterdam terminal offers extensive storage capacity and seamless connections to European pipeline networks and inland waterway systems.',
      facilities: 'Tank farm capacity: 30,000 m³, Rail connections, Pipeline access, European distribution hub',
      image: 'https://readdy.ai/api/search-image?query=Real%20Rotterdam%20Port%20Netherlands%20petroleum%20terminal%20with%20industrial%20storage%20tanks%20and%20port%20facilities%2C%20authentic%20documentary%20photography%20of%20actual%20working%20oil%20terminal%20at%20Rotterdam%20harbor%20showing%20modern%20infrastructure%20and%20vessel%20operations%2C%20professional%20photojournalism%20of%20genuine%20European%20petroleum%20port%20with%20real%20tank%20farm%20and%20loading%20equipment%2C%20realistic%20commercial%20photograph&width=600&height=400&seq=terminal-rotterdam-001&orientation=landscape',
      showLogo: true
    },
    {
      name: 'Fujairah Port',
      location: 'United Arab Emirates',
      description: 'Strategic location on the Indian Ocean providing direct access to Asian markets while bypassing the Strait of Hormuz. Our Fujairah terminal serves as a vital bunkering and storage hub for the Middle East petroleum trade.',
      facilities: 'Tank farm capacity: 20,000 m³, Bunkering services, Strategic location, Modern monitoring systems',
      image: 'https://readdy.ai/api/search-image?query=Real%20Fujairah%20Port%20UAE%20petroleum%20terminal%20with%20white%20storage%20tanks%20and%20Middle%20Eastern%20port%20infrastructure%2C%20authentic%20documentary%20photography%20of%20actual%20working%20oil%20terminal%20at%20Fujairah%20showing%20modern%20tank%20farm%20and%20vessel%20facilities%2C%20professional%20photojournalism%20of%20genuine%20petroleum%20port%20operations%20with%20real%20equipment%20and%20Arabian%20Gulf%20waters%2C%20realistic%20commercial%20photograph&width=600&height=400&seq=terminal-fujairah-001&orientation=landscape',
      showLogo: true
    },
    {
      name: 'Houston Port',
      location: 'United States',
      description: 'America\'s premier petroleum port and energy hub, providing access to U.S. Gulf Coast refineries and distribution networks. Our Houston terminal offers comprehensive storage and logistics services with full regulatory compliance.',
      facilities: 'Tank farm capacity: 35,000 m³, Refinery connections, Rail and truck access, U.S. regulatory compliance',
      image: 'https://readdy.ai/api/search-image?query=Real%20Houston%20Port%20Texas%20petroleum%20terminal%20with%20large%20industrial%20storage%20tanks%20and%20American%20port%20infrastructure%2C%20authentic%20documentary%20photography%20of%20actual%20working%20oil%20terminal%20at%20Houston%20Ship%20Channel%20showing%20modern%20tank%20farm%20and%20vessel%20loading%20facilities%2C%20professional%20photojournalism%20of%20genuine%20U.S.%20petroleum%20port%20operations%20with%20real%20equipment%2C%20realistic%20commercial%20photograph&width=600&height=400&seq=terminal-houston-001&orientation=landscape',
      showLogo: true
    },
    {
      name: 'Qingdao Port',
      location: 'China',
      description: 'Major petroleum terminal serving Northern China and Northeast Asian markets. Our Qingdao facility provides strategic storage and distribution capabilities with modern infrastructure and efficient customs clearance.',
      facilities: 'Tank farm capacity: 28,000 m³, Customs bonded area, Rail connections, Northern China distribution',
      image: 'https://readdy.ai/api/search-image?query=Real%20Qingdao%20Port%20China%20petroleum%20terminal%20with%20white%20storage%20tanks%20and%20Chinese%20port%20infrastructure%2C%20authentic%20documentary%20photography%20of%20actual%20working%20oil%20terminal%20at%20Qingdao%20harbor%20showing%20modern%20tank%20farm%20and%20vessel%20operations%2C%20professional%20photojournalism%20of%20genuine%20Chinese%20petroleum%20port%20with%20real%20equipment%20and%20Yellow%20Sea%20waters%2C%20realistic%20commercial%20photograph&width=600&height=400&seq=terminal-qingdao-001&orientation=landscape',
      showLogo: true
    },
    {
      name: 'Ningbo Port',
      location: 'China',
      description: 'One of China\'s busiest ports, serving the economically vibrant Yangtze River Delta region. Our Ningbo terminal provides comprehensive petroleum storage and distribution services with excellent connectivity to inland markets.',
      facilities: 'Tank farm capacity: 32,000 m³, Yangtze River access, Highway connections, Eastern China hub',
      image: 'https://readdy.ai/api/search-image?query=Real%20Ningbo%20Port%20China%20petroleum%20terminal%20with%20large%20industrial%20storage%20tanks%20and%20modern%20port%20facilities%2C%20authentic%20documentary%20photography%20of%20actual%20working%20oil%20terminal%20at%20Ningbo-Zhoushan%20harbor%20showing%20tank%20farm%20and%20vessel%20loading%20operations%2C%20professional%20photojournalism%20of%20genuine%20Chinese%20petroleum%20port%20with%20real%20infrastructure%20and%20East%20China%20Sea%2C%20realistic%20commercial%20photograph&width=600&height=400&seq=terminal-ningbo-001&orientation=landscape',
      showLogo: true
    },
    {
      name: 'Port Klang',
      location: 'Malaysia',
      description: 'Malaysia\'s largest port and a key petroleum distribution hub for the Strait of Malacca region. Our Port Klang terminal offers strategic positioning for Southeast Asian petroleum trade with modern storage facilities.',
      facilities: 'Tank farm capacity: 22,000 m³, Strait of Malacca access, Regional distribution, Modern infrastructure',
      image: 'https://readdy.ai/api/search-image?query=Real%20Port%20Klang%20Malaysia%20petroleum%20terminal%20with%20white%20storage%20tanks%20and%20Malaysian%20port%20infrastructure%2C%20authentic%20documentary%20photography%20of%20actual%20working%20oil%20terminal%20at%20Port%20Klang%20showing%20modern%20tank%20farm%20and%20vessel%20facilities%2C%20professional%20photojournalism%20of%20genuine%20Malaysian%20petroleum%20port%20operations%20with%20real%20equipment%20and%20Strait%20of%20Malacca%20waters%2C%20realistic%20commercial%20photograph&width=600&height=400&seq=terminal-klang-001&orientation=landscape',
      showLogo: true
    },
    {
      name: 'Pengerang Terminal',
      location: 'Malaysia',
      description: 'State-of-the-art petroleum terminal in Southern Malaysia, part of the Pengerang Integrated Petroleum Complex. Our facility provides advanced storage and blending capabilities serving regional and international markets.',
      facilities: 'Tank farm capacity: 26,000 m³, Blending facilities, Deep-water access, Integrated complex',
      image: 'https://readdy.ai/api/search-image?query=Real%20Pengerang%20Malaysia%20petroleum%20terminal%20with%20modern%20white%20storage%20tanks%20and%20advanced%20port%20infrastructure%2C%20authentic%20documentary%20photography%20of%20actual%20working%20oil%20terminal%20at%20Pengerang%20showing%20state-of-art%20tank%20farm%20and%20vessel%20loading%20facilities%2C%20professional%20photojournalism%20of%20genuine%20Malaysian%20petroleum%20complex%20with%20real%20equipment%20and%20South%20China%20Sea%2C%20realistic%20commercial%20photograph&width=600&height=400&seq=terminal-pengerang-001&orientation=landscape',
      showLogo: true
    },
  ];

  const capabilities = [
    {
      icon: 'ri-ship-line',
      title: 'Maritime Operations',
      description: 'Comprehensive vessel handling and cargo operations at all terminal locations',
    },
    {
      icon: 'ri-database-2-line',
      title: 'Storage Solutions',
      description: 'Extensive tank storage capacity with advanced monitoring systems',
    },
    {
      icon: 'ri-truck-line',
      title: 'Multimodal Transport',
      description: 'Seamless integration with rail, road, and pipeline networks',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Safety & Compliance',
      description: 'Full adherence to international safety and environmental standards',
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section 
          className="relative min-h-[500px] flex items-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 20, 60, 0.7), rgba(0, 20, 60, 0.7)), url('https://readdy.ai/api/search-image?query=Real%20international%20petroleum%20port%20terminal%20with%20large%20white%20storage%20tanks%20and%20vessel%20loading%20facilities%2C%20authentic%20documentary%20photography%20of%20actual%20working%20oil%20terminal%20showing%20modern%20infrastructure%20and%20maritime%20operations%2C%20professional%20photojournalism%20of%20genuine%20petroleum%20port%20with%20real%20tank%20farm%20and%20ships%2C%20realistic%20commercial%20photograph%20of%20functioning%20international%20petroleum%20terminal&width=1920&height=500&seq=terminals-hero-001&orientation=landscape')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full">
            <div className="max-w-3xl">
              <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Our Global Terminal Network
              </h1>
              <p className="text-xl text-gray-200 leading-relaxed">
                Strategic petroleum terminals across major ports worldwide, providing comprehensive storage and distribution services
              </p>
            </div>
          </div>
        </section>

        {/* Terminals Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Major Port Terminals</h2>
              <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
                SHENZHEN TONCENT operates petroleum terminals at strategic locations worldwide, ensuring efficient storage and distribution of petroleum products across global markets
              </p>
            </div>

            <div className="space-y-16">
              {terminals.map((terminal, index) => (
                <div key={index} className={`bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-teal-500`}>
                  <div className={`grid grid-cols-1 lg:grid-cols-2 gap-0 ${index % 2 === 0 ? '' : 'lg:grid-flow-dense'}`}>
                    <div className={`relative ${index % 2 === 0 ? '' : 'lg:col-start-2'}`}>
                      <img 
                        src={terminal.image} 
                        alt={terminal.name}
                        className="w-full h-full object-cover object-top min-h-[400px]"
                      />
                    </div>
                    <div className="p-12 flex flex-col justify-center">
                      <div className="flex items-center gap-3 mb-4">
                        <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center">
                          <i className="ri-map-pin-line text-2xl text-white"></i>
                        </div>
                        <div>
                          <h3 className="text-3xl font-bold text-gray-900">{terminal.name}</h3>
                          <p className="text-teal-600 font-semibold">{terminal.location}</p>
                        </div>
                      </div>
                      <p className="text-gray-600 mb-6 leading-relaxed text-lg">
                        {terminal.description}
                      </p>
                      <div className="bg-gray-50 rounded-lg p-6 mb-6">
                        <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                          <i className="ri-building-line text-teal-600"></i>
                          Terminal Facilities
                        </h4>
                        <p className="text-gray-700 leading-relaxed">{terminal.facilities}</p>
                      </div>
                      <Link 
                        to="/contact" 
                        className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 cursor-pointer whitespace-nowrap"
                      >
                        Contact for Services <i className="ri-arrow-right-line ml-2"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Services Integration */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Integrated Terminal Services</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Our terminal operations seamlessly integrate with our comprehensive logistics services
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {terminals.map((terminal, index) => (
                <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-teal-500">
                  <div className="relative h-64">
                    <img 
                      src={terminal.image} 
                      alt={terminal.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-start gap-3 mb-4">
                      <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-map-pin-line text-2xl text-white"></i>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-900 mb-1">{terminal.name}</h3>
                        <p className="text-gray-600 text-sm">{terminal.location}</p>
                      </div>
                    </div>
                    <p className="text-gray-700 mb-4 leading-relaxed">{terminal.description}</p>
                    <div className="space-y-2">
                      <div className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-database-2-line text-teal-600"></i>
                        <span><strong>Capacity:</strong> {terminal.capacity}</span>
                      </div>
                      <div className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-ship-line text-teal-600"></i>
                        <span><strong>Services:</strong> {terminal.services}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-blue-900">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">Connect with Our Terminal Network</h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Contact us to discuss how our global terminal presence can support your petroleum logistics needs
            </p>
            <Link 
              to="/contact" 
              className="inline-block px-8 py-4 bg-teal-500 text-white font-semibold rounded-lg hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get in Touch
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
